import { Helmet } from 'react-helmet-async';

const SITE = 'https://landlordcomply.uk';

// Per-page head tags. Use noindex on pages that should stay out of search
// (login, signup, report purchase). Do NOT also block those in robots.txt,
// or Google can't crawl the page to see the noindex.
export default function Seo({ title, description, path = '/', noindex = false, jsonLd }) {
  const url = SITE + path;
  return (
    <Helmet>
      {title && <title>{title}</title>}
      {description && <meta name="description" content={description} />}
      {noindex
        ? <meta name="robots" content="noindex, nofollow" />
        : <link rel="canonical" href={url} />}
      <meta property="og:url" content={url} />
      {title && <meta property="og:title" content={title} />}
      {description && <meta property="og:description" content={description} />}
      {jsonLd && <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>}
    </Helmet>
  );
}
